import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BankAccountDataService } from '../../services/bank-account-data.service';

@Component({
  selector: 'app-bank-account-card',
  templateUrl: './bank-account-card.component.html',
  styleUrls: ['./bank-account-card.component.scss']
})
export class BankAccountCardComponent implements OnInit {
  /**
   * Bank Data from other components like Consent Form
   */
  @Input()
  bank;
  @Input()
  bankDetails;
  // consentNumber;
  @Input()
  checkboxRequired;
  @Input()
  isNickname;
  @Input()
  isNicknameCard;

  consentForm: boolean = false;
  bankLogos: any;
  constructor(private route: Router,
    private bankService: BankAccountDataService) {
    if (this.route.url.indexOf('consent-confirm') >= 0) {
      this.consentForm = true;
    } else {
      this.consentForm = false;
    }
  }

  ngOnInit() {
    this.getBankLogos();
    //TODO: need to fix this
    if(this.bank['Account']) {
      this.bank['Account']['nickName'] = this.bank['Account']['nickName'] || this.bank['Account']['accType'];
    } else {
      this.bank['nickName'] = this.bank['nickName'] || this.bank['accountType'];
    }
  }

  getBankLogos() {
    this.bankService.getBanksLogos().subscribe((res) => {
      if (res != undefined) {
        this.bankLogos = res;
      }
    });
  }
}
